import { Outlet } from "react-router-dom";
import clsx from "clsx";
import { ToastViewport } from "@aurelia/ui";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingWhatsAppButton } from "./FloatingWhatsAppButton";
import { ScrollToTop } from "./ScrollToTop";
import { useHeroOverlapStore } from "../../lib/stores/heroOverlap";
import { useAnalyticsPageview } from "../../lib/useAnalyticsPageview";

export function PublicLayout() {
  const overDarkHero = useHeroOverlapStore((s) => s.overDarkHero);
  useAnalyticsPageview();

  return (
    <div
      className={clsx(
        "min-h-screen flex flex-col text-ink transition-colors duration-500",
        overDarkHero ? "bg-[#050813]" : "bg-canvas"
      )}
    >
      <ScrollToTop />
      <AnnouncementBar />
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
      <FloatingWhatsAppButton />
      <ToastViewport />
    </div>
  );
}
